import { getCurrentInstance } from "vue";

export function useModal() {
  const { proxy } = getCurrentInstance()!;
  return proxy?.$modal;
}
